import TechnologiesAnimation from '../../../../utils/TechnologiesAnimation';
import AnimateBubbles from './AnimateBubbles';
export default class TechnologiesPageInit {
    static init() {
        TechnologiesAnimation.init();
        AnimateBubbles.init();
    }
}
